import { createNode, DurationDataType, TemporalValueUnion } from '@glueapp/graph-types';
import { objectToTemporal, temporalToObject, toDuration } from '../../utils/temporal';

export const SubtractDuration = createNode({
    id: 'Subtract Duration',
    name: 'Subtract Duration',
    description: 'Subtracts a Duration from a Date, Time, DateTime, or ZonedDateTime value',
    aiDescription:
        'Takes a temporal value on the "Value" port (Date, Time, DateTime, or ZonedDateTime) and a Duration on the "Duration" port, and outputs the result of subtracting the duration on the "Result" port (same type as input).',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Value: { kind: 'generic', identifier: 'T', extends: TemporalValueUnion },
        Duration: DurationDataType,
    },
    outPorts: {
        Result: { kind: 'generic', identifier: 'T' },
    },
    execute: function (input) {
        const temporal = objectToTemporal(input.inPorts.Value);
        const duration = toDuration(input.inPorts.Duration);
        const result = temporal.subtract(duration);
        return { output: { Result: temporalToObject(result) } };
    },
});
